var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrosoftLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11L3 11L3 3L11 3L11 11Z",
    fill: "#FF5722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11L13 11V3L21 3V11Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H13V13L21 13V21Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H3L3 13L11 13L11 21Z",
    fill: "#03A9F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoft-logo.3626a660a18ed5528a0e347f187698c3.svg";